import { render, staticRenderFns } from "./matchLogInfo.vue?vue&type=template&id=baefcdee&scoped=true&lang=pug&"
import script from "./matchLogInfo.vue?vue&type=script&lang=js&"
export * from "./matchLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baefcdee",
  null
  
)

export default component.exports